/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import SettlementControllerDtoListSettlementType from './SettlementControllerDtoListSettlementType';

/**
 * The SettlementControllerDtoListSettlementRequest model module.
 * @module model/SettlementControllerDtoListSettlementRequest
 * @version 1.0
 */
class SettlementControllerDtoListSettlementRequest {
    /**
     * Constructs a new <code>SettlementControllerDtoListSettlementRequest</code>.
     * @alias module:model/SettlementControllerDtoListSettlementRequest
     */
    constructor() { 
        
        SettlementControllerDtoListSettlementRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SettlementControllerDtoListSettlementRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SettlementControllerDtoListSettlementRequest} obj Optional instance to populate.
     * @return {module:model/SettlementControllerDtoListSettlementRequest} The populated <code>SettlementControllerDtoListSettlementRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SettlementControllerDtoListSettlementRequest();

            if (data.hasOwnProperty('transactionStatus')) {
                obj['transactionStatus'] = ApiClient.convertToType(data['transactionStatus'], 'Number');
            }
            if (data.hasOwnProperty('settlementType')) {
                obj['settlementType'] = SettlementControllerDtoListSettlementType.constructFromObject(data['settlementType']);
            }
            if (data.hasOwnProperty('from')) {
                obj['from'] = ApiClient.convertToType(data['from'], 'Date');
            }
            if (data.hasOwnProperty('to')) {
                obj['to'] = ApiClient.convertToType(data['to'], 'Date');
            }
            if (data.hasOwnProperty('settlementIds')) {
                obj['settlementIds'] = ApiClient.convertToType(data['settlementIds'], ['String']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SettlementControllerDtoListSettlementRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SettlementControllerDtoListSettlementRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is an array
        if (!Array.isArray(data['settlementIds'])) {
            throw new Error("Expected the field `settlementIds` to be an array in the JSON data but got " + data['settlementIds']);
        }

        return true;
    }


}



/**
 * @member {Number} transactionStatus
 */
SettlementControllerDtoListSettlementRequest.prototype['transactionStatus'] = undefined;

/**
 * @member {module:model/SettlementControllerDtoListSettlementType} settlementType
 */
SettlementControllerDtoListSettlementRequest.prototype['settlementType'] = undefined;

/**
 * @member {Date} from
 */
SettlementControllerDtoListSettlementRequest.prototype['from'] = undefined;

/**
 * @member {Date} to
 */
SettlementControllerDtoListSettlementRequest.prototype['to'] = undefined;

/**
 * @member {Array.<String>} settlementIds
 */
SettlementControllerDtoListSettlementRequest.prototype['settlementIds'] = undefined;






export default SettlementControllerDtoListSettlementRequest;

